import { SmartJdDocument, SmartJdLock } from '../models/smart-jd.model';
import { formatTime } from './text';

/** Anything carrying the wire's two lock fields: a document, or a lock the mock stores per job. */
type Lockable = Pick<SmartJdDocument, 'lockedBy' | 'lockExpires'>;

/**
 * The edit lock, or null once it has lapsed. A holder with no expiry counts as no lock — see
 * `decisions/0006-a-holder-with-no-expiry-is-no-lock`.
 */
export function heldLock(source: Lockable): SmartJdLock | null {
  const { lockedBy, lockExpires } = source;
  if (!lockedBy || !lockExpires) return null;
  return new Date(lockExpires).getTime() > Date.now() ? { lockedBy, lockExpires } : null;
}

export function editLockMessage(lock: SmartJdLock): string {
  return lock.lockedBy + ' is editing this Smart JD until ' + formatTime(lock.lockExpires) + '.';
}
